import {Integer} from 'platform/foundation';

import {DashboardTileSize} from '../types/DashboardTileSize';

// Record columns of the list tiles: one for each half of the board the tile spans.
export const DASHBOARD_TILE_ROW_COLUMNS: Record<DashboardTileSize, Integer> = {
  quarter: 1,
  half: 1,
  tall: 1,
  wide: 2,
  large: 2,
};
